// Generated by scripts/generate-how-to-use.cjs; edit src/data/howToUse/*.json.
// Consumer instructions only; internal research is excluded.
import usageImage0 from "../Assets/products/klean-leaf-laundry-detergent-sheets-washing-machine.webp";
import usageImage1 from "../Assets/products/klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-washing-machine.webp";
import usageImage2 from "../Assets/products/klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-washing-machine.webp";
import usageImage3 from "../Assets/products/klean-leaf-baby-laundry-detergent-sheets-laundry-room.webp";
import usageImage4 from "../Assets/products/product-in-use/klean-leaf-pva-free-laundry-detergent-sheets-product-in-use.webp";
import usageImage5 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-sheets-vending-machine-pack-product-in-use.webp";
import usageImage6 from "../Assets/products/product-in-use/klean-leaf-color-catcher-sheets-product-in-use.webp";
import usageImage7 from "../Assets/products/klean-leaf-color-absorbing-sheets-washing-machine.webp";
import usageImage8 from "../Assets/products/klean-leaf-dryer-sheets-open-dryer.webp";
import usageImage9 from "../Assets/products/product-in-use/klean-leaf-premium-bamboo-fiber-dryer-sheets-product-in-use.webp";
import usageImage10 from "../Assets/products/klean-leaf-dissolvable-soften-sheets-laundry-room.webp";
import usageImage11 from "../Assets/products/product-in-use/klean-leaf-laundry-black-dyeing-magic-sheets-product-in-use.webp";
import usageImage12 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-powder-product-in-use.webp";
import usageImage13 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-tablets-product-in-use.webp";
import usageImage14 from "../Assets/products/product-in-use/klean-leaf-laundry-pods-product-in-use.webp";
import usageImage15 from "../Assets/products/product-in-use/klean-leaf-booster-laundry-pods-product-in-use.webp";
import usageImage16 from "../Assets/products/product-in-use/klean-leaf-fragrance-booster-beads-product-in-use.webp";
import usageImage17 from "../Assets/products/product-in-use/klean-leaf-fragrance-booster-beads-concentrated-product-in-use.webp";
import usageImage18 from "../Assets/products/product-in-use/klean-leaf-wool-dryer-balls-product-in-use.webp";
import usageImage19 from "../Assets/products/product-in-use/klean-leaf-dishwasher-detergent-sheets-product-in-use.webp";
import usageImage20 from "../Assets/products/product-in-use/klean-leaf-dishwasher-detergent-powder-product-in-use.webp";
import usageImage21 from "../Assets/products/product-in-use/klean-leaf-dishwasher-tablets-product-in-use.webp";
import usageImage22 from "../Assets/products/product-in-use/klean-leaf-dishwasher-pods-product-in-use.webp";
import usageImage23 from "../Assets/products/product-in-use/klean-leaf-dishwasher-pods-powder-liquid-product-in-use.webp";
import usageImage24 from "../Assets/products/product-in-use/klean-leaf-dishwasher-machine-cleaning-tablets-product-in-use.webp";
import usageImage25 from "../Assets/products/klean-leaf-toilet-bowl-cleaner-sheets-bathroom-use.webp";
import usageImage26 from "../Assets/products/product-in-use/klean-leaf-toilet-bowl-cleaner-powder-product-in-use.webp";
import usageImage27 from "../Assets/products/product-in-use/klean-leaf-toilet-bowl-cleaner-tablets-product-in-use.webp";
import usageImage28 from "../Assets/products/klean-leaf-floor-cleaning-sheets-mopping.webp";
import usageImage29 from "../Assets/products/product-in-use/klean-leaf-baby-nursing-bottle-cleaning-tablets-product-in-use.webp";
import usageImage30 from "../Assets/products/product-in-use/klean-leaf-laundry-machine-tablets-for-pet-owners-product-in-use.webp";
import usageImage31 from "../Assets/products/product-in-use/klean-leaf-coffee-machine-cleaning-tablets-product-in-use.webp";
import usageImage32 from "../Assets/products/product-in-use/klean-leaf-stain-removal-spray-product-in-use.webp";
import usageImage33 from "../Assets/products/product-in-use/klean-leaf-stain-removal-wipes-product-in-use.webp";
import usageImage34 from "../Assets/products/klean-leaf-stain-removal-pen-travel-use.webp";
import usageImage35 from "../Assets/products/klean-leaf-multi-purpose-cleaning-powder-spray-bottle.webp";
import usageImage36 from "../Assets/products/product-in-use/klean-leaf-multi-purpose-cleaning-tablets-product-in-use.webp";
import usageImage37 from "../Assets/products/klean-leaf-glass-cleaning-sheet-water-demonstration.webp";
import usageImage38 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-tablets-product-in-use.webp";
import usageImage39 from "../Assets/products/klean-leaf-hand-soap-sheet-single-use-handwashing.webp";
import usageImage40 from "../Assets/products/klean-leaf-hand-soap-sheet-concentrated-bottle-refill.webp";
import usageImage41 from "../Assets/products/product-in-use/klean-leaf-hand-soap-tablets-product-in-use.webp";
import usageImage42 from "../Assets/products/product-in-use/klean-leaf-plastic-spray-bottle-product-in-use.webp";
import usageImage43 from "../Assets/products/product-in-use/klean-leaf-glass-spray-bottle-product-in-use.webp";
import usageImage44 from "../Assets/products/product-in-use/klean-leaf-glass-foaming-bottle-product-in-use.webp";
import usageImage45 from "../Assets/products/klean-leaf-multi-purpose-cleaning-sheets-bottle-refill.webp";
import usageImage46 from "../Assets/products/klean-leaf-multi-purpose-cleaning-tablet-kit-kitchen-refill.webp";
import usageImage47 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-sheet-kit-product-in-use.webp";
import usageImage48 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-tablet-kit-product-in-use.webp";
import usageImage49 from "../Assets/products/klean-leaf-hand-soap-tablet-kit-bottle-refill.webp";
import usageImage50 from "../Assets/products/product-in-use/klean-leaf-laundry-dishwashing-multi-purpose-cleaning-tablet-kit-product-in-use.webp";

export const howToUseBySku = {
  "KL-LDS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place your clothes in the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Lay the sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a wash cycle suitable for your garments and start the machine."
    }
  ],
  "note": "Use the sheet quantity on the finished product label and follow garment care instructions.",
  "image": {
    "src": usageImage0,
    "alt": "Klean Leaf laundry detergent sheets box and stacked sheets beside a person adding a sheet to a washing machine",
    "fit": "cover"
  }
},
  "KL-LDS-EZ3": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place your clothes in the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Lay the sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a wash cycle suitable for your garments and start the machine."
    }
  ],
  "note": "Use the sheet quantity on the finished product label and follow garment care instructions.",
  "image": {
    "src": usageImage1,
    "alt": "Klean Leaf 3-in-1 enzyme laundry detergent sheets box and loose sheets on a washing machine",
    "fit": "cover"
  }
},
  "KL-LDS-SE5": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place your clothes in the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Lay the sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a wash cycle suitable for your garments and start the machine."
    }
  ],
  "note": "Use the sheet quantity on the finished product label and follow garment care instructions.",
  "image": {
    "src": usageImage2,
    "alt": "Klean Leaf solid enzyme laundry detergent sheets in a dark green box with stacked white sheets on a washing machine",
    "fit": "cover"
  }
},
  "KL-LDS-BY": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place your clothes in the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Lay the sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a wash cycle suitable for your garments and start the machine."
    }
  ],
  "note": "Use the sheet quantity on the finished product label and follow garment care instructions.",
  "image": {
    "src": usageImage3,
    "alt": "Klean Leaf baby laundry detergent sheets pouch and loose sheets in a laundry room with towels and plush toys",
    "fit": "cover"
  }
},
  "KL-LDS-PF": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place your clothes in the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Lay the sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a wash cycle suitable for your garments and start the machine."
    }
  ],
  "note": "Use the sheet quantity on the finished product label and follow garment care instructions.",
  "image": {
    "src": usageImage4,
    "alt": "A hand supporting a thin white laundry detergent sheet in window light",
    "fit": "cover"
  }
},
  "KL-CCS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sheets",
      "title": "Add the catcher sheet",
      "description": "Place the sheet in the washing machine drum with your laundry."
    },
    {
      "id": "step-2",
      "iconKey": "washer",
      "title": "Add detergent and wash",
      "description": "Add your laundry detergent, then run the cycle recommended for your garments."
    },
    {
      "id": "step-3",
      "iconKey": "removeSheet",
      "title": "Remove the used sheet",
      "description": "Take the sheet out after the wash and put it in the household waste."
    }
  ],
  "note": "Continue sorting laundry by color and fabric; follow the finished product label for sheet quantity.",
  "image": {
    "src": usageImage6,
    "alt": "A hand holding a white color-catcher sheet in front of an open washer with blue, burgundy and grey clothes",
    "fit": "cover"
  }
},
  "KL-CAS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sheets",
      "title": "Add the catcher sheet",
      "description": "Place the sheet in the washing machine drum with your laundry."
    },
    {
      "id": "step-2",
      "iconKey": "washer",
      "title": "Add detergent and wash",
      "description": "Add your laundry detergent, then run the cycle recommended for your garments."
    },
    {
      "id": "step-3",
      "iconKey": "removeSheet",
      "title": "Remove the used sheet",
      "description": "Take the sheet out after the wash and put it in the household waste."
    }
  ],
  "note": "Continue sorting laundry by color and fabric; follow the finished product label for sheet quantity.",
  "image": {
    "src": usageImage7,
    "alt": "Klean Leaf color-absorbing sheets box beside an open washing machine with a sheet resting on mixed laundry",
    "fit": "cover"
  }
},
  "KL-DRS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sheets",
      "title": "Add to damp laundry",
      "description": "Place the dryer sheet on top of damp clothes inside the tumble dryer."
    },
    {
      "id": "step-2",
      "iconKey": "dryer",
      "title": "Run the drying cycle",
      "description": "Select a drying setting suitable for your garments and start the dryer."
    },
    {
      "id": "step-3",
      "iconKey": "removeSheet",
      "title": "Discard the used sheet",
      "description": "Remove the sheet when you unload the dry clothes and put it in the household waste."
    }
  ],
  "note": "Check garment care before tumble drying and use the sheet quantity on the finished product label.",
  "image": {
    "src": usageImage8,
    "alt": "Klean Leaf dryer sheets box and stacked sheets beside an open dryer with a sheet resting on towels",
    "fit": "cover"
  }
},
  "KL-DRS-BF": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sheets",
      "title": "Add to damp laundry",
      "description": "Place the dryer sheet on top of damp clothes inside the tumble dryer."
    },
    {
      "id": "step-2",
      "iconKey": "dryer",
      "title": "Run the drying cycle",
      "description": "Select a drying setting suitable for your garments and start the dryer."
    },
    {
      "id": "step-3",
      "iconKey": "removeSheet",
      "title": "Discard the used sheet",
      "description": "Remove the sheet when you unload the dry clothes and put it in the household waste."
    }
  ],
  "note": "Check garment care before tumble drying and use the sheet quantity on the finished product label.",
  "image": {
    "src": usageImage9,
    "alt": "A thin white dryer sheet draped over a beige towel beside an open tumble dryer",
    "fit": "cover"
  }
},
  "KL-DSS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load the laundry",
      "description": "Place the garments in the washing machine and add your laundry detergent."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the softener sheet",
      "description": "Lay the dissolvable softener sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Select a wash cycle suited to your garments and start the machine."
    }
  ],
  "note": "Follow the finished product label for sheet quantity and fabric suitability; use these sheets in the washer.",
  "image": {
    "src": usageImage10,
    "alt": "Klean Leaf dissolvable fabric softener sheets box and loose white sheets on a laundry countertop beside a basket of towels",
    "fit": "cover"
  }
},
  "KL-DYS-BK": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sort",
      "title": "Separate black garments",
      "description": "Load suitable black garments into the washer, keeping them separate from other colors."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the color sheet",
      "description": "Place the sheet in the drum with the garments and add your laundry detergent."
    },
    {
      "id": "step-3",
      "iconKey": "removeSheet",
      "title": "Wash and remove the sheet",
      "description": "Run a cycle suited to the garments, then remove and discard the used sheet after washing."
    }
  ],
  "note": "Follow the finished product label for sheet quantity, suitable fabrics and washer aftercare before the next load.",
  "image": {
    "src": usageImage11,
    "alt": "A thin off-white laundry treatment sheet beside folded black cotton clothing on a dry counter",
    "fit": "cover"
  }
},
  "KL-DDS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dishes",
      "title": "Load the dishes",
      "description": "Arrange dishwasher-safe items in the racks, keeping the detergent dispenser and spray arms clear."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Put the sheet in the main detergent compartment, then close the dispenser."
    },
    {
      "id": "step-3",
      "iconKey": "dishwasher",
      "title": "Run the dishwasher",
      "description": "Close the machine and select a wash cycle suited to your dishes."
    }
  ],
  "note": "Follow the finished product label for sheet dosage and your dishwasher’s loading instructions.",
  "image": {
    "src": usageImage19,
    "alt": "A dry hand holding an ivory dishwasher detergent sheet with plates and glasses in an open dishwasher behind",
    "fit": "cover"
  }
},
  "KL-TBCS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sheets",
      "title": "Add the cleaning sheet",
      "description": "Place the sheet directly into the toilet bowl water and let it dissolve."
    },
    {
      "id": "step-2",
      "iconKey": "toiletBrush",
      "title": "Brush inside the bowl",
      "description": "Scrub the bowl with a toilet brush, reaching under the rim and around the waterline."
    },
    {
      "id": "step-3",
      "iconKey": "flush",
      "title": "Flush to finish",
      "description": "Flush the toilet to wash away the cleaning solution and loosened residue."
    }
  ],
  "note": "Use the sheet amount directed on the finished product label.",
  "image": {
    "src": usageImage25,
    "alt": "A Klean Leaf toilet cleaning sheet held above the toilet bowl",
    "fit": "cover"
  }
},
  "KL-FCS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "mop",
      "title": "Fill a mop bucket",
      "description": "Pour clean water into a mop bucket, leaving room for the mop and cleaning solution."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Dissolve the cleaning sheets",
      "description": "Add the cleaning sheets to the water and wait until they have dissolved fully."
    },
    {
      "id": "step-3",
      "iconKey": "mop",
      "title": "Mop the floor",
      "description": "Dip and wring out the mop, then clean the floor in manageable sections."
    }
  ],
  "note": "Follow the label’s dilution and rinsing directions, and check your flooring care instructions.",
  "image": {
    "src": usageImage28,
    "alt": "Klean Leaf floor cleaning sheets beside a mop on a floor",
    "fit": "cover"
  }
},
  "KL-GCS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dissolve",
      "title": "Dissolve the glass cleaning sheets",
      "description": "Add the glass cleaning sheets to water in a clean container and allow them to dissolve fully."
    },
    {
      "id": "step-2",
      "iconKey": "wipeGlass",
      "title": "Wipe the glass",
      "description": "Dampen a clean cloth with the prepared solution and wipe the glass surface."
    },
    {
      "id": "step-3",
      "iconKey": "wipeGlass",
      "title": "Dry with a clean cloth",
      "description": "Remove the remaining solution with a dry, lint-free cloth, working across the cleaned glass."
    }
  ],
  "note": "Follow the label for dilution and glass compatibility; avoid electronic screens unless specifically listed.",
  "image": {
    "src": usageImage37,
    "alt": "A Klean Leaf glass cleaning sheet being dissolved in a bowl of water",
    "fit": "cover"
  }
},
  "KL-HSS-SU": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "sheets",
      "title": "Take a dry soap sheet",
      "description": "Remove a soap sheet with dry hands and close the case to protect the remaining sheets."
    },
    {
      "id": "step-2",
      "iconKey": "washHands",
      "title": "Add water and lather",
      "description": "Wet the sheet in your palm and rub your hands together until the sheet dissolves into lather."
    },
    {
      "id": "step-3",
      "iconKey": "rinse",
      "title": "Rinse and dry your hands",
      "description": "Rinse away the lather with clean water, then dry your hands with a clean towel."
    }
  ],
  "note": "Keep the case and unused sheets dry.",
  "image": {
    "src": usageImage39,
    "alt": "Single-use Klean Leaf soap sheets beside hands being washed under running water",
    "fit": "cover"
  }
},
  "KL-HSS-CT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the foaming bottle",
      "description": "Remove the pump from a clean foaming soap bottle and pour water into the bottle."
    },
    {
      "id": "step-2",
      "iconKey": "addSheet",
      "title": "Dissolve the soap sheets",
      "description": "Add the concentrated soap sheets to the water and allow them to dissolve completely before fitting the pump."
    },
    {
      "id": "step-3",
      "iconKey": "washHands",
      "title": "Pump, wash and rinse",
      "description": "Pump soap onto wet hands, rub into a lather, then rinse with clean water and dry."
    }
  ],
  "note": "Follow the refill label for soap and water quantities; use a foaming dispenser.",
  "image": {
    "src": usageImage40,
    "alt": "A concentrated Klean Leaf hand soap sheet being added to water in a foaming bottle",
    "fit": "cover"
  }
},
  "KL-LDPW-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "scoop",
      "title": "Measure the powder",
      "description": "Use a dry scoop to measure powder for your laundry load."
    },
    {
      "id": "step-2",
      "iconKey": "dispenser",
      "title": "Add to the washer",
      "description": "Put powder in the compartment or drum location specified for powder detergent in your washer instructions."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Load and wash",
      "description": "Load your clothes, select a cycle suitable for the fabric, and start the machine."
    }
  ],
  "note": "Use the dosage on the finished product label and follow your washer instructions for powder detergent.",
  "image": {
    "src": usageImage12,
    "alt": "A hand holding a clear scoop of white laundry detergent powder with tiny blue granules near a washing machine",
    "fit": "cover"
  }
},
  "KL-MPCPW-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Add water to the bottle",
      "description": "Pour water into a clean, reusable spray bottle, leaving room for the cleaning powder."
    },
    {
      "id": "step-2",
      "iconKey": "scoop",
      "title": "Dissolve the cleaning powder",
      "description": "Add the cleaning powder to the water and let it dissolve fully before attaching the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "wipeSurface",
      "title": "Spray and wipe",
      "description": "Spray the prepared cleaner onto a suitable surface and wipe it with a clean cloth."
    }
  ],
  "note": "Follow the finished product label for dilution and suitable surfaces.",
  "image": {
    "src": usageImage35,
    "alt": "Klean Leaf multi-purpose cleaning powder beside a spray bottle of prepared solution",
    "fit": "cover"
  }
},
  "KL-DDPW-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dishes",
      "title": "Load the dishes",
      "description": "Arrange dishwasher-safe items in the racks, keeping the detergent dispenser and spray arms clear."
    },
    {
      "id": "step-2",
      "iconKey": "scoop",
      "title": "Add the detergent powder",
      "description": "Measure powder into the main detergent compartment and close the dispenser door."
    },
    {
      "id": "step-3",
      "iconKey": "dishwasher",
      "title": "Run the dishwasher",
      "description": "Close the machine and select a wash cycle suited to your dishes."
    }
  ],
  "note": "Use the powder dose shown on the finished product label, taking load size and water hardness into account.",
  "image": {
    "src": usageImage20,
    "alt": "Fine white dishwasher detergent powder with small blue flecks in a scoop held beside an open dishwasher",
    "fit": "cover"
  }
},
  "KL-TBCPW-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "scoop",
      "title": "Add powder to the bowl",
      "description": "Measure the powder and pour it directly into the water in the toilet bowl."
    },
    {
      "id": "step-2",
      "iconKey": "toiletBrush",
      "title": "Let it work, then brush",
      "description": "Allow the cleaner to work, then brush around the bowl and beneath the rim."
    },
    {
      "id": "step-3",
      "iconKey": "flush",
      "title": "Flush the bowl",
      "description": "Flush away the cleaning solution and any residue loosened by brushing."
    }
  ],
  "note": "Follow the finished product label for powder dosage and contact time.",
  "image": {
    "src": usageImage26,
    "alt": "Fine white toilet bowl cleaning powder in an unbranded scoop on a bathroom ledge with a toilet in the background",
    "fit": "cover"
  }
},
  "KL-DDT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dishes",
      "title": "Load the dishes",
      "description": "Arrange dishwasher-safe items in the racks, keeping the detergent dispenser and spray arms clear."
    },
    {
      "id": "step-2",
      "iconKey": "tablet",
      "title": "Add the detergent tablet",
      "description": "Set the detergent tablet inside the main detergent compartment and close its door."
    },
    {
      "id": "step-3",
      "iconKey": "dishwasher",
      "title": "Run the dishwasher",
      "description": "Close the machine and select a wash cycle suited to your dishes."
    }
  ],
  "note": "Follow the finished product label for tablet dosage and any outer-wrapper instructions.",
  "image": {
    "src": usageImage21,
    "alt": "A small white rectangular dishwasher detergent tablet held between dry fingers in front of an open dishwasher",
    "fit": "cover"
  }
},
  "KL-DMCT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dishwasher",
      "title": "Empty the dishwasher",
      "description": "Remove all dishes and utensils, leaving the racks in place for the cleaning cycle."
    },
    {
      "id": "step-2",
      "iconKey": "tablet",
      "title": "Add the cleaning tablet",
      "description": "Place the machine-cleaning tablet in the detergent compartment and close the dispenser."
    },
    {
      "id": "step-3",
      "iconKey": "dishwasher",
      "title": "Run the cleaning cycle",
      "description": "Run the dishwasher’s cleaning or normal cycle without dishes, then let the interior dry."
    }
  ],
  "note": "Follow the finished product label for dosage and your appliance manual for the cleaning cycle.",
  "image": {
    "src": usageImage24,
    "alt": "A small round white dishwasher machine cleaning tablet held between fingertips with an empty dishwasher in the background",
    "fit": "cover"
  }
},
  "KL-MPCT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill a spray bottle",
      "description": "Remove the spray head and pour water into a clean bottle, leaving room for the refill."
    },
    {
      "id": "step-2",
      "iconKey": "addTablet",
      "title": "Dissolve the cleaning tablet",
      "description": "Add the multi-purpose cleaning tablet to the water and let it dissolve completely before replacing the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "wipeSurface",
      "title": "Spray and wipe",
      "description": "Spray the prepared cleaner onto a suitable surface and wipe away dirt with a clean cloth."
    }
  ],
  "note": "Follow the finished product label for dilution and suitable surfaces.",
  "image": {
    "src": usageImage36,
    "alt": "A hand holding a pale yellow cleaning tablet above a spray bottle containing water",
    "fit": "cover"
  }
},
  "KL-LDT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "tablet",
      "title": "Add the tablet",
      "description": "Place the laundry detergent tablet directly into the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "laundry",
      "title": "Load the clothes",
      "description": "Add your laundry to the drum, leaving enough room for it to move."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a cycle suitable for the garments and start the washing machine."
    }
  ],
  "note": "Follow the finished product label for tablet quantity, wrapping instructions and garment suitability.",
  "image": {
    "src": usageImage13,
    "alt": "A small blue-speckled white laundry detergent tablet resting on a dry palm with a washing machine in the background",
    "fit": "cover"
  }
},
  "KL-HST-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the foaming bottle",
      "description": "Remove the pump and pour water into a clean foaming soap bottle, leaving room for the refill."
    },
    {
      "id": "step-2",
      "iconKey": "addTablet",
      "title": "Dissolve the soap tablet",
      "description": "Add the hand soap tablet to the water and allow it to dissolve fully before dispensing."
    },
    {
      "id": "step-3",
      "iconKey": "washHands",
      "title": "Pump, wash and rinse",
      "description": "Fit the pump, dispense soap onto wet hands, lather thoroughly, then rinse with clean water and dry."
    }
  ],
  "note": "Follow the refill label for soap and water quantities; use a foaming dispenser.",
  "image": {
    "src": usageImage41,
    "alt": "A hand holding a pale green speckled soap tablet above water in an open foaming soap bottle",
    "fit": "cover"
  }
},
  "KL-BBCT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "babyBottle",
      "title": "Separate the bottle parts",
      "description": "Take bottles, teats and compatible feeding accessories apart, then place them in a clean bowl of water."
    },
    {
      "id": "step-2",
      "iconKey": "tablet",
      "title": "Add the cleaning tablet",
      "description": "Add the tablet to the water and let the separated parts soak in the cleaning solution."
    },
    {
      "id": "step-3",
      "iconKey": "rinse",
      "title": "Rinse and air dry",
      "description": "Rinse each part thoroughly with fresh water and allow everything to air dry before reassembly."
    }
  ],
  "note": "Follow the finished product label for dilution and soaking time, and the feeding accessories’ care instructions.",
  "image": {
    "src": usageImage29,
    "alt": "A small white Klean Leaf baby bottle cleaning tablet held between fingers with clean disassembled feeding bottles on a drying rack behind",
    "fit": "cover"
  }
},
  "KL-LMT-PT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "washer",
      "title": "Empty the washer",
      "description": "Take out all laundry and leave the drum empty for machine cleaning."
    },
    {
      "id": "step-2",
      "iconKey": "tablet",
      "title": "Add the cleaning tablet",
      "description": "Place the machine-cleaning tablet directly into the empty drum, away from the detergent drawer."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Run and wipe clean",
      "description": "Run the washer’s cleaning cycle, then wipe away any remaining residue with a clean cloth."
    }
  ],
  "note": "Use the label’s tablet dose and your washer’s cleaning-cycle guidance; this product is for the machine, not pets.",
  "image": {
    "src": usageImage30,
    "alt": "White blue-speckled Klean Leaf laundry machine cleaning tablets in close-up on a dry counter with an empty washing machine and folded pet blanket behind",
    "fit": "cover"
  }
},
  "KL-TBCT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "tablet",
      "title": "Add the cleaning tablet",
      "description": "Drop the tablet into the toilet bowl water and allow it to dissolve completely."
    },
    {
      "id": "step-2",
      "iconKey": "toiletBrush",
      "title": "Brush the bowl",
      "description": "Scrub the inside of the bowl, including the waterline and beneath the rim."
    },
    {
      "id": "step-3",
      "iconKey": "flush",
      "title": "Flush to finish",
      "description": "Flush the toilet to remove the cleaning solution and loosened residue."
    }
  ],
  "note": "Use the tablet dose directed on the finished product label for bowl cleaning.",
  "image": {
    "src": usageImage27,
    "alt": "A small blue-and-white Klean Leaf toilet cleaning tablet held between fingers with a closed toilet softly visible behind",
    "fit": "cover"
  }
},
  "KL-CMCT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "coffeeMachine",
      "title": "Prepare the coffee machine",
      "description": "Empty used coffee and the drip tray, then fill the water reservoir with fresh water."
    },
    {
      "id": "step-2",
      "iconKey": "tablet",
      "title": "Add the cleaning tablet",
      "description": "Insert the tablet at the location and stage specified by your machine’s cleaning program."
    },
    {
      "id": "step-3",
      "iconKey": "rinse",
      "title": "Complete cleaning and rinsing",
      "description": "Run the cleaning program and complete its fresh-water rinse sequence before making coffee again."
    }
  ],
  "note": "Use only with a compatible tablet-cleaning program and follow the finished product label for dosage.",
  "image": {
    "src": usageImage31,
    "alt": "A small white Klean Leaf coffee-machine cleaning tablet held between fingers near an unbranded home espresso machine",
    "fit": "cover"
  }
},
  "KL-GCT-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the cleaning bottle",
      "description": "Remove the spray head and add water to a clean, reusable bottle for the glass cleaner."
    },
    {
      "id": "step-2",
      "iconKey": "addTablet",
      "title": "Dissolve the glass cleaning tablet",
      "description": "Place the glass-cleaning tablet in the water and let it dissolve fully before attaching the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "wipeGlass",
      "title": "Spray and wipe the glass",
      "description": "Spray the prepared solution onto suitable glass and wipe it dry with a clean, lint-free cloth."
    }
  ],
  "note": "Follow the label for dilution and glass compatibility; avoid electronic screens unless specifically listed.",
  "image": {
    "src": usageImage38,
    "alt": "Loose pale blue Klean Leaf glass cleaning tablets in macro detail beside a gray microfiber cloth on a window sill",
    "fit": "cover"
  }
},
  "KL-LDP-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "pod",
      "title": "Add the intact pod",
      "description": "With dry hands, place the intact laundry pod directly into the empty washer drum."
    },
    {
      "id": "step-2",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place the clothes in the drum, leaving room for them to move during washing."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Select a cycle suitable for your garments and start the washing machine."
    }
  ],
  "note": "Use the pod quantity on the finished product label and reseal the pack after use.",
  "image": {
    "src": usageImage14,
    "alt": "A single intact pale-gold Klean Leaf laundry pod resting in a dry open palm with an open washing machine behind",
    "fit": "cover"
  }
},
  "KL-DDP-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dishes",
      "title": "Load the dishes",
      "description": "Arrange dishwasher-safe items in the racks, keeping the detergent dispenser and spray arms clear."
    },
    {
      "id": "step-2",
      "iconKey": "pod",
      "title": "Place the pod inside",
      "description": "With dry hands, place the intact pod in the dry detergent compartment and close the dispenser."
    },
    {
      "id": "step-3",
      "iconKey": "dishwasher",
      "title": "Run the dishwasher",
      "description": "Close the machine and select a wash cycle suited to your dishes."
    }
  ],
  "note": "Keep the pod intact and use the amount directed on the finished product label.",
  "image": {
    "src": usageImage22,
    "alt": "A small yellow, green and white dishwasher detergent pod held between dry fingertips in a kitchen.",
    "fit": "cover"
  }
},
  "KL-DDP-PL": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dishes",
      "title": "Load the dishes",
      "description": "Arrange dishwasher-safe items in the racks, keeping the detergent dispenser and spray arms clear."
    },
    {
      "id": "step-2",
      "iconKey": "pod",
      "title": "Place the pod inside",
      "description": "With dry hands, place the intact pod in the dry detergent compartment and close the dispenser."
    },
    {
      "id": "step-3",
      "iconKey": "dishwasher",
      "title": "Run the dishwasher",
      "description": "Close the machine and select a wash cycle suited to your dishes."
    }
  ],
  "note": "Keep the pod intact and use the amount directed on the finished product label.",
  "image": {
    "src": usageImage23,
    "alt": "Close-up of powder-and-liquid dishwasher pods with purple, green and blue compartments on a kitchen counter.",
    "fit": "cover"
  }
},
  "KL-LBP-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "pod",
      "title": "Add the booster pod",
      "description": "With dry hands, place the intact booster pod directly into the empty washer drum."
    },
    {
      "id": "step-2",
      "iconKey": "laundry",
      "title": "Add detergent and laundry",
      "description": "Add your usual laundry detergent in its normal place, then load the clothes without overfilling."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Select a cycle suitable for your garments and start the washing machine."
    }
  ],
  "note": "Follow the finished product label for booster dosage and fabric suitability; reseal the pack after use.",
  "image": {
    "src": usageImage15,
    "alt": "A dry hand holds an intact white powder-filled laundry booster pod at an empty washer drum.",
    "fit": "cover"
  }
},
  "KL-FBB-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "beads",
      "title": "Add the fragrance beads",
      "description": "Pour the measured beads directly into the empty washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "laundry",
      "title": "Add detergent and laundry",
      "description": "Add your laundry detergent in its normal place, then load the clothes."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Select a wash cycle suitable for your garments and start the washing machine."
    }
  ],
  "note": "Dose the beads according to the finished product label and keep them out of dispenser drawers.",
  "image": {
    "src": usageImage16,
    "alt": "Pale mint fragrance booster beads pouring from a plain scoop directly into an empty washing machine drum.",
    "fit": "cover"
  }
},
  "KL-FBB-CT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "beads",
      "title": "Add the fragrance beads",
      "description": "Pour the measured beads directly into the empty washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "laundry",
      "title": "Add detergent and laundry",
      "description": "Add your laundry detergent in its normal place, then load the clothes."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Select a wash cycle suitable for your garments and start the washing machine."
    }
  ],
  "note": "Use the concentrated formula dosage on the finished product label; add beads only to the drum.",
  "image": {
    "src": usageImage17,
    "alt": "Small pale purple fragrance booster beads in a cupped hand",
    "fit": "cover"
  }
},
  "KL-SRS-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Check the fabric",
      "description": "Read the garment care label and test the spray on a hidden area before treating the stain."
    },
    {
      "id": "step-2",
      "iconKey": "stainSpray",
      "title": "Spray the stained area",
      "description": "Apply the spray directly to the mark and let it work before washing."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Wash the garment",
      "description": "Launder the treated garment with your usual detergent, following its fabric care instructions."
    }
  ],
  "note": "Follow the finished product label for fabric suitability and treatment time.",
  "image": {
    "src": usageImage32,
    "alt": "A hand holding a white stain-removal spray bottle above a mark on a white shirt",
    "fit": "cover"
  }
},
  "KL-SRW-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "stainWipe",
      "title": "Lift off loose residue",
      "description": "Remove excess food or liquid gently, taking care not to spread the stain."
    },
    {
      "id": "step-2",
      "iconKey": "stainWipe",
      "title": "Wipe the stained area",
      "description": "Open a packet and wipe gently from the outer edge of the stain toward its center."
    },
    {
      "id": "step-3",
      "iconKey": "laundry",
      "title": "Rinse or launder",
      "description": "Rinse or launder the treated garment as needed, following its fabric care instructions."
    }
  ],
  "note": "Test a hidden area first and follow the finished product label for any rinsing or laundering requirements.",
  "image": {
    "src": usageImage33,
    "alt": "A hand pressing a white wipe onto a brown mark on a light blouse",
    "fit": "cover"
  }
},
  "KL-SRP-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "stainWipe",
      "title": "Prepare the stained fabric",
      "description": "Lift away loose residue and place a clean, absorbent white cloth beneath the stain."
    },
    {
      "id": "step-2",
      "iconKey": "stainPen",
      "title": "Roll over the stain",
      "description": "Uncap the pen and gently move the roller across the mark to apply the cleaner."
    },
    {
      "id": "step-3",
      "iconKey": "stainWipe",
      "title": "Blot away the residue",
      "description": "Use a clean, damp cloth to dab away the loosened stain and excess cleaning solution."
    }
  ],
  "note": "Check the garment care label and test a hidden area before treatment.",
  "image": {
    "src": usageImage34,
    "alt": "A Klean Leaf stain removal pen carried beside a travel pouch",
    "fit": "cover"
  }
},
  "KL-WDB-RG": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dryerBalls",
      "title": "Add the dryer balls",
      "description": "Put the wool balls in the tumble dryer with damp laundry."
    },
    {
      "id": "step-2",
      "iconKey": "dryer",
      "title": "Dry your laundry",
      "description": "Choose a drying setting appropriate for the garments and start the dryer."
    },
    {
      "id": "step-3",
      "iconKey": "dryerBalls",
      "title": "Keep for the next load",
      "description": "Remove your dry laundry and keep the balls for their next use."
    }
  ],
  "note": "Follow your garment care labels and the dryer instructions.",
  "image": {
    "src": usageImage18,
    "alt": "Four ivory wool dryer balls nestled among cream and grey towels in an open tumble dryer",
    "fit": "cover"
  }
},
  "KL-LDS-VM": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "laundry",
      "title": "Load your laundry",
      "description": "Place your clothes in the washing machine drum."
    },
    {
      "id": "step-2",
      "iconKey": "sheets",
      "title": "Add the detergent sheet",
      "description": "Lay the sheet on top of the clothes inside the drum."
    },
    {
      "id": "step-3",
      "iconKey": "washer",
      "title": "Start the wash",
      "description": "Choose a wash cycle suitable for your garments and start the machine."
    }
  ],
  "note": "Use the sheet quantity on the finished product label and follow garment care instructions.",
  "image": {
    "src": usageImage5,
    "alt": "A dry hand holding a thin white laundry detergent sheet beside an open laundromat washing machine",
    "fit": "cover"
  }
},
  "KL-SBT-PL": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "bottle",
      "title": "Open the empty bottle",
      "description": "Unscrew the spray head and rinse the empty bottle with clean water before refilling."
    },
    {
      "id": "step-2",
      "iconKey": "fillBottle",
      "title": "Add a compatible cleaner",
      "description": "Pour a prepared cleaning solution into the bottle, leaving space to reinsert the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "spray",
      "title": "Replace the sprayer and use",
      "description": "Screw the spray head onto the bottle and squeeze the trigger to apply the cleaner."
    }
  ],
  "note": "Cleaner is sold separately; use a compatible solution and follow its application directions.",
  "image": {
    "src": usageImage42,
    "alt": "A hand squeezing the white trigger of a clear plastic spray bottle over a kitchen countertop",
    "fit": "cover"
  }
},
  "KL-FBT-GL": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "bottle",
      "title": "Remove the foaming pump",
      "description": "Unscrew the pump and rinse the empty bottle before filling it with soap solution."
    },
    {
      "id": "step-2",
      "iconKey": "fillBottle",
      "title": "Add foaming soap solution",
      "description": "Pour a prepared foaming hand soap solution into the bottle, leaving space for the pump."
    },
    {
      "id": "step-3",
      "iconKey": "soapPump",
      "title": "Replace the pump and dispense",
      "description": "Screw the pump back onto the bottle and press it to dispense foam for handwashing."
    }
  ],
  "note": "Soap is sold separately; choose a formula made for foaming dispensers.",
  "image": {
    "src": usageImage44,
    "alt": "Hands pressing the white pump of a clear glass foaming bottle to dispense soap beside a sink",
    "fit": "cover"
  }
},
  "KL-SBT-GL": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "bottle",
      "title": "Open the empty bottle",
      "description": "Unscrew the spray head and rinse the empty bottle with clean water before refilling."
    },
    {
      "id": "step-2",
      "iconKey": "fillBottle",
      "title": "Add a compatible cleaner",
      "description": "Pour a prepared cleaning solution into the bottle, leaving space to reinsert the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "spray",
      "title": "Replace the sprayer and use",
      "description": "Screw the spray head onto the bottle and squeeze the trigger to apply the cleaner."
    }
  ],
  "note": "Cleaner is sold separately; use a compatible solution and follow its application directions.",
  "image": {
    "src": usageImage43,
    "alt": "A hand holding a clear glass spray bottle with a sage green sleeve beside a window",
    "fit": "cover"
  }
},
  "KL-MPCS-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the spray bottle",
      "description": "Remove the spray head and add water to the reusable bottle for your cleaning refill."
    },
    {
      "id": "step-2",
      "iconKey": "addSheet",
      "title": "Dissolve the cleaning sheets",
      "description": "Add the multi-purpose cleaning sheets and allow them to dissolve fully before replacing the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "wipeSurface",
      "title": "Spray and wipe",
      "description": "Spray the prepared cleaner onto a suitable surface and wipe it with a clean cloth."
    }
  ],
  "note": "Follow the finished product label for dilution and suitable surfaces.",
  "image": {
    "src": usageImage45,
    "alt": "Klean Leaf multi-purpose cleaning sheets being added to a reusable spray bottle",
    "fit": "cover"
  }
},
  "KL-MPCT-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill a spray bottle",
      "description": "Remove the spray head and pour water into a clean bottle, leaving room for the refill."
    },
    {
      "id": "step-2",
      "iconKey": "addTablet",
      "title": "Dissolve the cleaning tablet",
      "description": "Add the multi-purpose cleaning tablet to the water and let it dissolve completely before replacing the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "wipeSurface",
      "title": "Spray and wipe",
      "description": "Spray the prepared cleaner onto a suitable surface and wipe away dirt with a clean cloth."
    }
  ],
  "note": "Follow the finished product label for dilution and suitable surfaces.",
  "image": {
    "src": usageImage46,
    "alt": "Klean Leaf multi-purpose tablet kit being prepared in its reusable spray bottle",
    "fit": "cover"
  }
},
  "KL-GCS-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "dissolve",
      "title": "Dissolve the glass cleaning sheets",
      "description": "Add the glass cleaning sheets to water in a clean container and allow them to dissolve fully."
    },
    {
      "id": "step-2",
      "iconKey": "wipeGlass",
      "title": "Wipe the glass",
      "description": "Dampen a clean cloth with the prepared solution and wipe the glass surface."
    },
    {
      "id": "step-3",
      "iconKey": "wipeGlass",
      "title": "Dry with a clean cloth",
      "description": "Remove the remaining solution with a dry, lint-free cloth, working across the cleaned glass."
    }
  ],
  "note": "Follow the label for dilution and glass compatibility; avoid electronic screens unless specifically listed.",
  "image": {
    "src": usageImage47,
    "alt": "An adult cleaning glass with the Klean Leaf glass cleaning sheet kit's black-trigger spray bottle and a cloth",
    "fit": "cover"
  }
},
  "KL-GCT-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the cleaning bottle",
      "description": "Remove the spray head and add water to a clean, reusable bottle for the glass cleaner."
    },
    {
      "id": "step-2",
      "iconKey": "addTablet",
      "title": "Dissolve the glass cleaning tablet",
      "description": "Place the glass-cleaning tablet in the water and let it dissolve fully before attaching the spray head."
    },
    {
      "id": "step-3",
      "iconKey": "wipeGlass",
      "title": "Spray and wipe the glass",
      "description": "Spray the prepared solution onto suitable glass and wipe it dry with a clean, lint-free cloth."
    }
  ],
  "note": "Follow the label for dilution and glass compatibility; avoid electronic screens unless specifically listed.",
  "image": {
    "src": usageImage48,
    "alt": "An adult cleaning glass with the Klean Leaf glass cleaning tablet kit's white-trigger spray bottle and a cloth",
    "fit": "cover"
  }
},
  "KL-HSS-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the foaming bottle",
      "description": "Remove the pump from a clean foaming soap bottle and pour water into the bottle."
    },
    {
      "id": "step-2",
      "iconKey": "addSheet",
      "title": "Dissolve the soap sheets",
      "description": "Add the concentrated soap sheets to the water and allow them to dissolve completely before fitting the pump."
    },
    {
      "id": "step-3",
      "iconKey": "washHands",
      "title": "Pump, wash and rinse",
      "description": "Pump soap onto wet hands, rub into a lather, then rinse with clean water and dry."
    }
  ],
  "note": "Follow the refill label for soap and water quantities; use a foaming dispenser.",
  "image": {
    "src": usageImage40,
    "alt": "A hand holding a concentrated Klean Leaf hand soap sheet above a foaming bottle of water",
    "fit": "cover"
  }
},
  "KL-HST-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "fillBottle",
      "title": "Fill the foaming bottle",
      "description": "Remove the pump and pour water into a clean foaming soap bottle, leaving room for the refill."
    },
    {
      "id": "step-2",
      "iconKey": "addTablet",
      "title": "Dissolve the soap tablet",
      "description": "Add the hand soap tablet to the water and allow it to dissolve fully before dispensing."
    },
    {
      "id": "step-3",
      "iconKey": "washHands",
      "title": "Pump, wash and rinse",
      "description": "Fit the pump, dispense soap onto wet hands, lather thoroughly, then rinse with clean water and dry."
    }
  ],
  "note": "Follow the refill label for soap and water quantities; use a foaming dispenser.",
  "image": {
    "src": usageImage49,
    "alt": "A hand holding a Klean Leaf hand soap tablet above an open refill bottle",
    "fit": "cover"
  }
},
  "KL-HCT-KT": {
  "availability": "ready",
  "steps": [
    {
      "id": "step-1",
      "iconKey": "washer",
      "title": "Wash the laundry",
      "description": "Place laundry detergent tablets in the empty washer drum, add clothes and start a cycle suited to the fabrics."
    },
    {
      "id": "step-2",
      "iconKey": "dispenser",
      "title": "Clean the dishes",
      "description": "Load the dishwasher, place dishwasher detergent tablets in the detergent dispenser, close it and run the selected cycle."
    },
    {
      "id": "step-3",
      "iconKey": "addTablet",
      "title": "Prepare the surface cleaner",
      "description": "Dissolve multi-purpose tablets fully in a spray bottle of water, fit the sprayer, then spray and wipe suitable surfaces."
    }
  ],
  "note": "Use each labeled refill separately; follow its dosage and dilution directions, and never mix the products together.",
  "image": {
    "src": usageImage50,
    "alt": "Three groups of round and rectangular cleaning tablets on a counter beside folded towels and dishes",
    "fit": "cover"
  }
},
};
